import React from 'react'
import { t } from 'ttag'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import save from '@h2/assets/svg/icons/save.svg'
import resume from '@h2/assets/svg/icons/resume.svg'
import careerHub from '@h2/assets/svg/icons/userHub.svg'
import warning from '@h2/assets/svg/icons/warning.svg'
import groupMedium from '@h2/assets/svg/icons/groupMedium.svg'

import { useTitleChange } from '../../util/hooks'

const LoginBenefits = () => {
  useTitleChange(t`Why Register?`)

  return (
    <div className="container">
      <div className="col-xs-8">
        <div className="row">
          <div className="col-xs-2 text-center">
            <img
              src={save}
              className="img-responsive"
              style={{ maxWidth: '75px', margin: 'auto' }}
            />
          </div>
          <div className="col-xs-10">
            <h3 className="section-heading" style={{ marginBottom: '.5em' }}>
              {t`Save Your Work`}
            </h3>
            <p>{t`Assessments, resumes, and even your exploration history are saved to your account automatically, so it is there whenever you come back. `}</p>
          </div>
        </div>
        <div className="row" style={{ marginTop: '25px' }}>
          <div className="col-xs-2 text-center">
            <img
              src={like}
              className="img-responsive"
              style={{ maxWidth: '75px', margin: 'auto' }}
            />
          </div>
          <div className="col-xs-10">
            <h3 className="section-heading" style={{ marginBottom: '.5em' }}>
              {t`Personalized Results`}
            </h3>
            <p>{t`Your history and ratings allow us to tailor your listings to show you things that are more relevant to you.`}</p>
          </div>
        </div>
        <div className="row" style={{ marginTop: '25px' }}>
          <div className="col-xs-2 text-center">
            <img
              src={resume}
              className="img-responsive"
              style={{ maxWidth: '75px', margin: 'auto' }}
            />
          </div>
          <div className="col-xs-10">
            <h3 className="section-heading" style={{ marginBottom: '.5em' }}>
              {t`Additional Functionality`}
            </h3>
            <p>{t`When you sign in, you'll have access to additional functionality that requires an account, such as the resume builder, and more...`}</p>
          </div>
        </div>
        <div className="row" style={{ marginTop: '25px' }}>
          <div className="col-xs-2 text-center">
            <img
              src={careerHub}
              className="img-responsive"
              style={{ maxWidth: '75px', margin: 'auto' }}
            />
          </div>
          <div className="col-xs-10">
            <h3 className="section-heading" style={{ marginBottom: '.5em' }}>
              {t`Career Hub`}
            </h3>
            <p>{t`All of your activity is saved in one place, where you easily get back to it. From your Career Hub, you can even find recommendations on things to explore next.`}</p>
          </div>
        </div>
        <div className="actions text-center" style={{ marginTop: '25px' }}>
          <Link to="/register" className="btn btn-success">{t`Get Started Now`}</Link>
        </div>
      </div>
      <div className="col-xs-4 with-border">
        <div className="container-fluid">
          <div className="row">
            <h4 className="section-heading">{t`Plus, even more if you use it with an advisor - such as your teacher, counselor, librarian, or other educator.`}</h4>
          </div>
          <div className="row">
            <div className="col-xs-3 text-center">
              <img
                src={warning}
                className="img-responsive"
                style={{ maxWidth: '75px', margin: 'auto' }}
              />
            </div>
            <div className="col-xs-9">
              <h3 className="section-heading">{t`Password Help`}</h3>
              <p>{t`When you use ${dynamicValues.systemName} with an advisor, they can automatically reset your password for you. No worrying about password clues, no lost e-mails.`}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-3 text-center">
              <img
                src={groupMedium}
                className="img-responsive"
                style={{ maxWidth: '75px', margin: 'auto' }}
              />
            </div>
            <div className="col-xs-9">
              <h3 className="section-heading">{t`Easy Sharing`}</h3>
              <p>{t`When you use ${dynamicValues.systemName} with an advisor, your work is automatically shared - so there is no need to submit it separately. `}</p>
            </div>
          </div>

          <div className="row">
            <p style={{ fontWeight: 'bold' }} className="text-center">
              {t`Ask your advisor to get you setup in ${dynamicValues.systemName}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(
  _ => ({}),
  dispatch => ({ dispatch })
)(LoginBenefits)
